export enum ENV {
    LOCAL = 'local',
    DEV = 'dev',
    TEST = 'test',
    PROD = 'prod',
}

export const getCurrentEnv = () => {
    switch (window.location.host) {
        case 'localhost:3000':
        case 'brfweb.jmapi.io':
            return ENV.LOCAL;
        case 'brf-web-dev.azureedge.net':
        case 'dev-brfweb.jm.se':
            return ENV.DEV;
        case 'brf-web-test.azureedge.net':
        case 'test-brfweb.jm.se':
            return ENV.TEST;
        case 'brf-web-prod.azureedge.net':
        case 'prod-brfweb.jm.se':
            return ENV.PROD;
        case 'dsbrf.jm.se':
            return ENV.PROD;
    }
    return '';
}

export const getApiURL = () => {
    return `${window.location.origin}/api`;
};
